import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const updateMfaSlice = getBulkActionSlice(
    'updateMfaSettingsResult',
);

export const selectUpdateMfaSettingsUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.updateMfaSettingsResult.uuid;

export const selectUpdateMfaSettingsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.updateMfaSettingsResult.shown;

export const selectUpdateMfaSettingsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.updateMfaSettingsResult.backgroundTask;


export const {
    setUuid,
    setShown,
    setBackgroundTask,
    clearResult,
} = updateMfaSlice.actions;
